export default [
  {
    path: '/application/list',
    name: 'Application List',
    component: () => import('@/views/application/application-list/index.vue'),
    meta: {
      resourceCode: 'application:list',
    },
  },
];
